
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(webpack_sharing_consume_default_(react\-((dom_react|router\-dom_react\-router)\-dom|i18next_react\-i18next)|clsx_clsx|date\-fns_date\-fns|easepick_core_easepick_core\-webpack_sharing_consume_default_e\-476c46)|vendors\-node_modules_squiz_component\-editing\-ui_lib_index_css\-node_modules_modern\-normalize_m\-abf2cf)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
